import { useQuery } from "@tanstack/react-query"
import { getSchoolLevels } from "../../../../services/dashboard/apiCourses"

export const useGetchoolLevels = ({ filterObject } = {}) => {

    const { data, isPending, isSuccess } = useQuery({
        queryKey: ["schoolLevelsDashboard", filterObject], queryFn: () => getSchoolLevels({ filterObject })
    })


    return { isPending, data, isSuccess }
}